import _ from "lodash";
import React, { useEffect, useState } from "react";
import styles from "./scss/activity.module.scss";
import { WtButton } from "../../../shared/widges/Button/button";
import iconcall from "../../../styles/images/contactcall.svg";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import { Col, Collapse, Row } from "antd";
import { CallServices, CoreServices } from "../../../base/service/apiServices";
import moment from "moment";

function ActivityInfo({ inputValue }: any) {
  const [data, setData] = useState<any>({});
  const [apidata, setApidata] = useState<any>([]);
  const onChange = (key: string) => {};
  const AudioPlayer1: any = AudioPlayer;

  useEffect(() => {
    CallServices.get(`/get_session_all_list/${inputValue.phoneNumber}`).then((value: any) => {
      if (value && value.data.statusCode === 200) {
        const body = {
          agentConnectTime: moment(value.data.getSessionListRes[0].agentConnectTime).format("DD/MM/YYYY , HH:MM"),
          calledNumber: value.data.getSessionListRes[0].calledNumber,
          summary: value.data.getSessionListRes[0].summary,
          status: value.data.getSessionListRes[0].status,
          agentDetails: value.data.getSessionListRes[0].agentDetails,
        };
        setApidata(body);
      }
    });
  }, []);
  const body = {};

  // const mapApiData = (data: any) => {
  //
  //   const dataArray = [] as any;
  //   for (let api of data) {
  //     dataArray.push({
  //       agentConnectTime: moment(
  //         api?.agentConnectTime.format("DD/MM/YYYY,HH:MM")
  //       ),
  //     });
  //   }
  //

  //   setApidata(dataArray);
  // };

  const { Panel } = Collapse;

  return (
    <>
      <Row>
        <Col sm={24}>
          <Row className={styles.activityview}>
            <img className={styles.lefticon} src={iconcall} alt="" />
            <Row className={styles.activityinner}>
              <Col sm={12}>
                <h4>{apidata?.agentDetails}</h4>
                <h5>{apidata?.agentConnectTime}</h5>
              </Col>
              <Col sm={12}>
                <p>
                  <WtButton name={apidata?.status} className={`${styles.resolved}`} />
                </p>
              </Col>
              <Col sm={24}>{apidata?.summary}</Col>
            </Row>
          </Row>
        </Col>
      </Row>
    </>
  );
}
export { ActivityInfo };
